import { useReduxConstants } from 'metrix-common3';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StoreFrontHelmet from '../../components/Helmet';
import { AppRoutes } from '../../components/Routes';
import SupportPartner from '../../components/SupportPartner';

const App = (props) => {
    const { subfolderPrefix } = props.context;
    const location = useLocation();
    const reduxConstants = useReduxConstants();

    const { colors: Colors } = reduxConstants.constants;

    useEffect(() => {
        // Handle viewport meta tag
        if (!window.matchMedia('(min-width: 576px)').matches) {
            const viewport = document.getElementsByTagName('META').viewport;
            if (!/maximum-scale/.test(viewport.content)) {
                viewport.content += ', maximum-scale=1';
            }
        }

        // Configure Zendesk settings
        window.zESettings = {
            webWidget: {
                color: {
                    theme: `${Colors?.Primary}`,
                },
            },
        };

        // Update Zendesk widget offset based on route
        if (location.pathname === `${subfolderPrefix}/workflow`) {
            window.zESettings.webWidget.offset = {
                vertical: '50px',
                mobile: {
                    vertical: '85px',
                },
            };
        } else if (location.pathname === `${subfolderPrefix}/quote`) {
            window.zESettings.webWidget.offset = {
                vertical: '80px',
                mobile: {
                    vertical: '85px',
                },
            };
        }
    }, [location.pathname, subfolderPrefix, Colors]);

    return (
        <>
            <StoreFrontHelmet {...props} />
            <AppRoutes {...props} />
            <SupportPartner {...props} />
        </>
    );
};

export default App;
